module.exports = __webpack_public_path__ + "img/product-details-2.3d7a5a2d.jpg";